import React from 'react';

import RenderStaticHTML from '../RenderStaticHTML';

const Circle = ({
	id, label, rootClassnames, disabled, checkboxRef, checked, handleChange, ...props
}) => {
	return (
		<label htmlFor={id} className={rootClassnames}>
			<input
				{...props}
				disabled={disabled}
				id={id}
				ref={checkboxRef}
				type={'checkbox'}
				checked={checked}
				onChange={handleChange}
			/>
			<span aria-hidden />
			<RenderStaticHTML
				html={label}
				as={`span`}
			/>
		</label>
	);
};

export default Circle;
